// extracted by mini-css-extract-plugin
module.exports = {"luckyFlopgame":"components_luckyFlopgame__JP1i4"};